import { EndPointService } from 'src/services/api-handlers/axios';

const ROUTE = 'conversation-starters';

const list = (params: any) => EndPointService.get(`/${ROUTE}`, params);
const get = (id: string) => EndPointService.get(`/${ROUTE}/${id}`);
const update = (id: string, data: any) => EndPointService.patch(`/${ROUTE}/${id}`, data);
const create = (data: any) => EndPointService.post(`/${ROUTE}/`, data);
const remove = (id: string) => EndPointService.delete(`/${ROUTE}/${id}`);

export default {
    list,
    get,
    update,
    create,
    remove,
};
